export default "__VITE_ASSET__051c8ad0__"